import styled from 'styled-components'
import { ComponentLayout } from '../../../components/layouts/ComponentLayout'
import { BodyLarge, Title2, Title4 } from '../../../components/styles/Typography'
import { theme } from '../../../theme/theme'
import { useGetPortalGeneralPageById } from '../../../api/contentful/contentfulQueries'
import { PreviewGuard } from '../../../components/PreviewGuard'
import { isILinkList } from '@estercare/ester-shared'
import { SupportBlock } from '../../../components/SupportBlock'
import { LoadingSpinner } from '../../../components/LoadingSpinner'
import { useTranslation } from 'react-i18next'
import { CONTENTFUL_ENTRY_IDS } from '../../../constants/contentfulEntries'

export const EmployeeSupportIndex = () => {
  const { t } = useTranslation()
  const { data: supportPage, isLoading } = useGetPortalGeneralPageById(CONTENTFUL_ENTRY_IDS.SUPPORT_EMPLOYEE)
  if (isLoading) return <LoadingSpinner />

  const supportContent = supportPage?.fields
  if (!supportContent) return <PreviewGuard />

  const { title, description, contentBlocks } = supportContent

  return (
    <>
      <ComponentLayout>
        <StyledTitle2>{title}</StyledTitle2>
        <StyledBodyLarge>{description}</StyledBodyLarge>
      </ComponentLayout>
      <ComponentLayout paddingTop={0}>
        {contentBlocks &&
          contentBlocks.map((block, index) => {
            return isILinkList(block) && <SupportBlock key={index} linkList={block.fields} />
          })}
      </ComponentLayout>
      <ComponentLayout paddingTop={0}>
        <OtherQuestions>
          <Title4>{t('employee.support.questionsTitle')}</Title4>
          <StyledBodyLarge>{t('employee.support.contactText')}</StyledBodyLarge>
        </OtherQuestions>
      </ComponentLayout>
    </>
  )
}

const StyledTitle2 = styled(Title2)`
  margin-bottom: ${theme.spacing.xsmall}px;
`

const StyledBodyLarge = styled(BodyLarge)`
  max-width: 640px;
  a {
    color: ${theme.color.plumMid};
    font-weight: 500;
  }
`

const OtherQuestions = styled.div`
  background-color: ${theme.color.beigeDark};
  padding: ${theme.spacing.xlarge}px;
  border-radius: ${theme.spacing.medium}px;
`
